import {
	Component,
	Input,
	OnDestroy,
	OnInit,
	Output,
	EventEmitter
} from '@angular/core';
import { Subscription } from 'rxjs';
import { CommonError, CommonErrorState } from './definitions';
import { CommonErrorService } from './common-error.service';
import { AnalyticsService } from '../../services/analytics/analytics.service';
import { LocalStorageService } from '../../services/local-storage/local-storage.service';
import { Router } from '@angular/router';
import { ApplicationPath } from '../../services/shared/shared-enums';

@Component({
	selector: 'tmhna-portal-common-error',
	templateUrl: './template/common-error.component.html',
	styleUrls: ['./template/common-error.component.scss']
})
export class CommonErrorComponent implements CommonError, OnInit, OnDestroy 
{
	private subscriptions: Subscription = new Subscription();
	errorMessage: string = '';
  @Input() set state(value: CommonErrorState) 
	{
		this.service.updateState(value);
	}
  get state(): CommonErrorState 
  {
  	return this.service.state;
  }
  get isTmhCorporateAdmin(): boolean
  {
  	return this.localStorageService.getTmhCorporateAdminDetails() !== null;
  }
  @Output() stateChanged: EventEmitter<CommonErrorState> =
  	new EventEmitter<CommonErrorState>();

  constructor(private service: CommonErrorService, private analyticsService: AnalyticsService, private localStorageService: LocalStorageService, private router: Router) 
  {
  	this.isValidUser();
  }

  ngOnInit(): void 
  {
  	this.initSubscriptions();
  	this.analyticsService.trackByEvent({
  		event: 'errorPage',
  		page: {
  			name: 'error'
  		},
  		error: {
  			message: this.state.messages.map(message => message.message).join('. ')
  		}
  	});
  }
  ngOnDestroy(): void 
  {
  	this.destroySubscriptions();
  }

  private initSubscriptions(): void 
  {
  	const stateChangeSubs: Subscription = this.service.stateChanged.subscribe(
  		(next: CommonErrorState) =>
  		{
  			this.stateChanged.emit(next);
  		} 
  	);
  	this.subscriptions.add(stateChangeSubs);
  }
  private destroySubscriptions(): void 
  {
  	this.subscriptions.unsubscribe();
  }
  isValidUser()
  {
  	if(this.router.url.includes(ApplicationPath.authError))
  	{
  		Promise.all([ this.localStorageService.getItems('isTmhCorporateAdmin'), this.localStorageService.getItems('isPortalUser') ]).then((values) => 
  		{
  			if(values[0] !== 'true' && values[1] !== 'true')
  			{
  				this.router.navigate([ApplicationPath.authentication]);
  			}
  		});
  	}
  }
}
